<script>
import VSelect from '@alfsnd/vue-bootstrap-select';
import { BTable, BFormDatepicker, BInputGroup, BFormInput, BInputGroupAppend, BModal, BFormSelect } from 'bootstrap-vue'
import DibbleTranslation from "../../translation/translation";
import DibbleAPI from "../../api";
import DibbleJS from "../../dibble";
import Helper from '../../appHelper';

export default {
    name: "BusinessProfileUsers",
    components: {
        VSelect, BTable, BFormDatepicker, BFormSelect,
        BInputGroup, BFormInput, BInputGroupAppend, BModal
    },
    data() {
        return {            
            translate: DibbleTranslation,
            showInfoModal: false,
            formUser:[],
            countries: [
                {
                    value: null,
                    text: "-- None --"
                }
            ],
            totalUser: 0,
            user_status: [],
            filter_from_date: "",
            filter_to_date: "",
            filter_to_date_formatted: '',
            filter_to_date_selected: '',
            search: {
                keyword: '',
                status: {},
                country: {
                    value: null,
                    text: "-- None --"
                },
            },
            fields: [
                { key: 'business_name', label: DibbleTranslation.trans('pinker.businessName'), sortable: true },
                { key: 'logo_img', label: DibbleTranslation.trans('pinker.logoImage'), sortable: true },
                { key: 'phone_number', label: DibbleTranslation.trans('pinker.phoneNumber'), sortable: true },
                { key: 'created_date', label: DibbleTranslation.trans('pinker.registrationDate'), sortable: true,
                  formatter: (value) => {
                    return value ? this.$moment(value).format('DD/MM/YYYY') : ''
                  },
                },
                { key: 'is_active', label: DibbleTranslation.trans('pinker.isActive'), sortable: false},
                { key: 'business_id', label: DibbleTranslation.trans('pinker.businessNumber'), sortable: true },
                { key: 'business_category', label: DibbleTranslation.trans('pinker.businessCat'), sortable: true },
                { key: 'feedback_list', label: DibbleTranslation.trans('pinker.feedbackList'), sortable: true },
                // { key: 'statistic', label: 'Statistic', sortable: true },
                // { key: 'email', label: 'Email', sortable: true },
                // // { key: 'avatar', label: 'Image', sortable: false },
                // { key: 'birthdate', label: 'Date Of Birth', sortable: true,
                //   formatter: (value) => {
                //     return value ? this.$moment(value).format('DD/MM/YY') : ''
                //   },},
                // { key: 'language', label: 'Language', sortable: true },
                // { key: 'subscription_plan', label: 'Subscription Plan', sortable: false },
                // { key: 'subscription_renewal_date', label: 'Subscription renewal date', sortable: false },
                // { key: 'subscription_amount', label: 'Subscription Amount', sortable: false },
                // { key: 'image_audio_allow', label: 'Number of images / audio recording allowed', sortable: false },
                // { key: 'image_audio_amount', label: 'Number of images / audio recording used so far', sortable: false },
                // { key: 'is_reported', label: 'Has this user been reported', sortable: false },
                // { key: 'is_report_other', label: 'Is this user reported someone', sortable: false },
            ],
            selectedStatus: null,
            statusOptions: [
                { value: null, text: DibbleTranslation.trans("pinker.selectUserStatus") },
                { value: true, text: DibbleTranslation.trans("pinker.active") },
                { value: false, text: DibbleTranslation.trans("pinker.inActive") }
            ],
            selectedBusinessCat: null,
            businessCatOptions: [
                { value: null, text: DibbleTranslation.trans("pinker.selectBusinessCategory") },
                { value: 1, text: DibbleTranslation.trans("pinker.selfEmployed") },
                { value: 2, text: DibbleTranslation.trans("pinker.employee") },
                { value: 3, text: DibbleTranslation.trans("pinker.organization") },
                { value: 4, text: DibbleTranslation.trans("pinker.company") },
            ],
            selectedUserType: null,
            UserTypeOptions: [
                { value: null, text: DibbleTranslation.trans("pinker.selectUserType") },
                { value: 3, text: DibbleTranslation.trans("pinker.private") },
                { value: 4, text: DibbleTranslation.trans("pinker.business") },
                { value: 5, text: DibbleTranslation.trans("pinker.privateABusiness") },
            ],
            users: [],
            sourceUsers: [],
            pagination: {
                currentPage: 1,
                totalPage: 0
            },
            feedbackListForm: {
                isOpen: false,
                title: DibbleTranslation.trans("pinker.feedbackList"),
                items: []
            },
        }
    },
    mounted() {
        const scrollContent = document.getElementById('scroll-main-content')
        scrollContent.style.height = window.innerHeight*0.8 +  "px"
    },
    created() {
        this.loadUsers();
    },
    methods: {
        moment(value) {
            return this.$moment(value)
        },
        momentWithFormat(value, dateFormat) {
            return this.$moment(value, dateFormat)
        },
        isPrivateUserOnly(userItem) {
            return userItem.user_type === Helper.userType.private;
        },
        onFilterchange: function (filterName, event) {
            if (filterName === "dateRangeFrom") {
                this.filter_from_date = event.target.value;
                this.filterUsers("date");
            } else if (filterName === "dateRangeTo") {
                this.filter_to_date = event.target.value;
                this.filterUsers("date");
            } else if (filterName === "status") {                
                this.filterUsers("status");
            } else if (filterName === "userType") {
                this.filterUsers("userType");
            } else if (filterName === "businessCat") {
                this.filterUsers("businessCat");
            }
        },
        filterUsers (filterType) {
            console.log("filterType" + " : " + filterType);
            if (filterType === "date") {
                const tempUserList = []
                console.log("filterType 1");
                if (this.filter_from_date !== "" && this.filter_to_date !== "") {
                    console.log("filterType2");
                    const momentFrom = this.momentWithFormat(this.filter_from_date, DibbleAPI.apiDateFormat);
                    const momentTo = this.momentWithFormat(this.filter_to_date, DibbleAPI.apiDateFormat);
                    this.sourceUsers.map((item, index) => {
                        const userCreatedTime = this.momentWithFormat(item.created_date, DibbleAPI.apiDateFormatFull);
                        if (userCreatedTime.isAfter(momentFrom) && userCreatedTime.isBefore(momentTo)) {
                            tempUserList.push(item)
                        }
                        return item;
                    })
                    this.users = tempUserList
                } else {
                    if (this.filter_from_date !== "") {
                        console.log("filterType 3");
                        const momentFrom = this.momentWithFormat(this.filter_from_date, DibbleAPI.apiDateFormat);
                        this.sourceUsers.map((item, index) => {
                            const userCreatedTime = this.momentWithFormat(item.created_date, DibbleAPI.apiDateFormatFull);                            
                            if (userCreatedTime.isAfter(momentFrom)) {
                                tempUserList.push(item)
                            }
                            return item;
                        })
                        this.users = tempUserList
                    } else if (this.filter_to_date !== "") {
                        console.log("filterType 4");
                        const momentTo = this.momentWithFormat(this.filter_to_date, DibbleAPI.apiDateFormat);
                        this.sourceUsers.map((item, index) => {
                            const userCreatedTime = this.momentWithFormat(item.created_date, DibbleAPI.apiDateFormatFull);
                            if (userCreatedTime.isBefore(momentTo)) {
                                tempUserList.push(item)
                            }
                            return item;
                        })
                        this.users = tempUserList
                    } else {
                        this.users = this.sourceUsers
                    }
                }                
            } else if (filterType === "status") {
                if (this.selectedStatus === null) {
                    this.users = this.sourceUsers
                } else {
                    const tempUserList = []
                    this.sourceUsers.map((item, index) => {
                        const activeValue = this.selectedStatus ? 1 : 0
                        if (item.is_active === activeValue) {
                            tempUserList.push(item)
                        }
                        return item;
                    })
                    this.users = tempUserList
                }
            } else if (filterType === "userType") {
                if (this.selectedUserType === null) {
                    this.users = this.sourceUsers
                } else {
                    const tempUserList = []
                    this.sourceUsers.map((item, index) => {
                        if (item.user_type === this.selectedUserType) {
                            tempUserList.push(item)
                        }
                        return item;
                    })
                    this.users = tempUserList
                }
            } else if (filterType === "businessCat") {
                // selectedBusinessCat
                if (this.selectedBusinessCat === null) {
                    this.users = this.sourceUsers
                } else {
                    const tempUserList = []
                    this.sourceUsers.map((item, index) => {
                        if (item.business_category === this.selectedBusinessCat) {
                            tempUserList.push(item)
                        }
                        return item;
                    })
                    this.users = tempUserList
                }
            }
        },
        getBackgroundColorCss (color) {
            return "background-color: " + color;
        },
        getDisplayName (feedbackItem) {
            if (feedbackItem.user_sender_displayname=== 1) {
                return feedbackItem.user_name
            } else {
                return this.translate.trans('pinker.anonymous')                
            }
        },
        showFeedbackListModal (dataItem) {
            const params = {
                '#request': DibbleAPI.api.getUserProfile,
                user_id: dataItem.user_id,
                date_start: "",
                date_end: "",
                feedback_user_type: 4
            };
            DibbleJS.showLoader();
            DibbleJS.callAnomyousRequest(params, (responseData) => {
                DibbleJS.hideLoader();
                if (DibbleAPI.isResponseSuccess(responseData)) {
                    if (responseData.feedbacks != null && responseData.feedbacks.length > 0) {
                        this.feedbackListForm.isOpen = true
                        this.feedbackListForm.items = responseData.feedbacks
                    } else {
                        alert  (this.translate.trans('pinker.noFeedback'));
                    }
                } else {
                    DibbleJS.toastErrorMessage(responseData.message);
                }
            })  
        },
        closeFeebacklistModal () {
            this.feedbackListForm.isOpen = false
        },
        showBusinessProfile(userId) {
            alert(userId)
        },
        showFeedbacklist(userId) {
            alert(userId)
        },
        loadUsers() {
            const params = {
                '#request': DibbleAPI.api.admin.getBusinessUsers,
                sort_direction: false,
                // start_date: '2023-01-01',
                // end_date: this.moment().format(DibbleAPI.apiDateFormat),
                // user_type: Helper.userType.business,
                // business_category: 0
            };

            DibbleJS.showLoader();
            DibbleJS.callApiRequest(params, this._onLoadUsersSuccess)
        },
        _onLoadUsersSuccess(responseData) {
            DibbleJS.hideLoader();
            if (DibbleAPI.isResponseSuccess(responseData)) {
                this.users = responseData.businesses_list;
                this.sourceUsers = responseData.businesses_list;
            } else {
                DibbleJS.toastErrorMessage(responseData.message);
            }
        },
        searchUser (searhKey) {            
            if (searhKey === "") {
                this.users = this.sourceUsers
            } else {
                const tempUserList = []
                this.sourceUsers.map((item, index) => {
                    if (item.business_name != null) {
                        const fullname = item.business_name == null ? "" : item.business_name;
                        if (fullname.toLowerCase().includes(searhKey.toLowerCase())){
                            tempUserList.push(item)
                        }
                        return item;
                    } else {
                        return null;
                    }
                })
                this.users = tempUserList
            }
        },
        showStatistic (dataItem, isAppStatistic) {
            this.statisticForm.isAllApp = isAppStatistic
            if (isAppStatistic) {
                this.statisticForm.title = this.translate.trans('users.statistic.title')+ ": " + this.translate.trans('users.statistic.all')
                console.log("isAppStatistic")
                this.loadAppStatistic((data) => {                
                    this.statisticForm.isOpenStatisticModal = true
                    this.statisticForm.total_memo = data.number_of_memories
                    this.statisticForm.total_safe_memo = data.number_of_safe_memories
                    this.statisticForm.total_space_memo = data.number_of_space_memories
                    this.statisticForm.total_ghost_memo = data.number_of_ghost_memories
                    this.statisticForm.total_share_memo = data.number_of_shared_memories
                    this.statisticForm.total_report_to_user = data.number_of_user_has_been_reported
                    this.statisticForm.total_repost_from_user = data.number_of_user_reported_other_users
                    this.statisticForm.total_complete_questionair = data.questionnaire_is_complete     
                    this.statisticForm.total_turnover_all = data.subscription     
                    this.statisticForm.total_turnover_each_subscription = data.subscription_plan     
                })
            } else {
                this.statisticForm.title = this.translate.trans('users.statistic.title') + ": " + dataItem.first_name + " " + dataItem.last_name
                this.loadUserStatistic(
                    dataItem.user_id, 
                    (data) => {                        
                        this.statisticForm.isOpenStatisticModal = true
                        this.statisticForm.total_memo = data.user_statistics.number_of_memories
                        this.statisticForm.total_safe_memo = data.user_statistics.number_of_safe_memories
                        this.statisticForm.total_space_memo = data.user_statistics.number_of_space_memories
                        this.statisticForm.total_ghost_memo = data.user_statistics.number_of_ghost_memories
                        this.statisticForm.total_share_memo = data.user_statistics.number_of_shared_memories
                        this.statisticForm.total_report_to_user = data.user_statistics.number_of_user_has_been_reported
                        this.statisticForm.total_repost_from_user = data.user_statistics.number_of_user_reported_other_users
                        this.statisticForm.total_complete_questionair = data.user_statistics.is_complete                        
                    }
                )
            }
        },
        loadUserStatistic (userId, callback) {
            DibbleJS.showLoader()
            const rq = {
                "#request": DibbleAPI.api.getUserStatistic,
                user_id: userId
            }
            DibbleJS.callApiRequest( 
                rq,
                (data) => {
                    DibbleJS.hideLoader()
                    if (DibbleAPI.isResponseSuccess(data)){
                        callback(data)
                    } else {
                        DibbleJS.toastErrorMessage(data.message)
                    }
                }
            )
        },
        loadAppStatistic (callback) {
            DibbleJS.showLoader()
            const rq = {
                "#request": DibbleAPI.api.getAllUserStatistic
            }
            DibbleJS.callApiRequest( 
                rq,
                (data) => {
                    DibbleJS.hideLoader()
                    if (DibbleAPI.isResponseSuccess(data)){
                        callback(data)
                    } else {
                        DibbleJS.toastErrorMessage(data.message)
                    }
                }
            )
        },
        closeStatisticModal () {
            this.statisticForm.isOpenStatisticModal = false
        },
        checkShowHeritageButton (item) {
            if ((item.timeline_email != null && item.timeline_email !== '') 
                || (item.safe_box_email != null && item.safe_box_email !== '')) {                    
                    return item.heritage_send_status
            } else {
                return ""
            }
        },
        updateHeritage (item) {
            const params = {
                "#request": DibbleAPI.api.sendHeritage,
                user_id: item.user_id
            };
            console.log(JSON.stringify(params))
            DibbleJS.showLoader();
            DibbleJS.callApiRequest(params, 
            (data) => {
                DibbleJS.hideLoader();
                if (DibbleAPI.isResponseSuccess(data)) {
                    DibbleJS.toastSuccessMessage(data.message);
                    this.loadUsers()
                } else {
                    DibbleJS.toastErrorMessage(data.message);
                }
            })
        },
        cancelHeritage (item) {
            const params = {
                "#request": DibbleAPI.api.cancelSendHeritage,
                user_id: item.user_id
            };
            console.log(JSON.stringify(params))
            DibbleJS.showLoader();
            DibbleJS.callApiRequest(params, 
            (data) => {
                DibbleJS.hideLoader();
                if (DibbleAPI.isResponseSuccess(data)) {
                    DibbleJS.toastSuccessMessage(data.message);
                    this.loadUsers()
                } else {
                    DibbleJS.toastErrorMessage(data.message);
                }
            })
        },
        toggleUserActive(item) {
            const params = {
              '#request': DibbleAPI.api.blockUser,
              user_id: item.user_id,
              status: item.is_active === 1
            };

            DibbleJS.showLoader();
            DibbleJS.callApiRequest(params, (responseData) => {
                DibbleJS.hideLoader();
                if (DibbleAPI.isResponseSuccess(responseData)) {
                  DibbleJS.toastSuccessMessage(responseData.message);
                  this.loadUsers();
                } else {
                  DibbleJS.toastErrorMessage(responseData.message);
                }
            })
        }
    }
}
</script>

<style>
    .user-image {
        width: 40px;
        height: 40px;
    }
    .v-dropdown-container {
        max-height: 250px;
        overflow-y: scroll;
    }
    .small-text-box {
        width: 50px
    }
    .medium-text-box {
        width: 120px
    }    
</style>

<template src="./Templates/BusinessProfileUsers.html"></template>


